import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { InputPercent } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import useAnalytics from '../../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const PropertyTaxRateInput: React.FC<RentVsBuyInput> = ({
  placeholder,
  value,
  errorMessage,
  analytics,
  dispatch,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const segmentAbstract = useAnalytics();
  const decimalValue = value;
  const percentageValue = !_.isNil(decimalValue)
    ? num.formatPercent(decimalValue)
    : '';
  const percentagePlaceholder = !_.isNil(placeholder)
    ? num.formatPercent(placeholder)
    : '';
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_n',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        entityName: 'property_tax_rate',
        field_type: 'user_type_input',
        field_value: e.target.value,
        field: 'Property Tax Rate',
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'propertyTaxRate',
      calculator: RENT_VS_BUY,
      inputType: 'percentage',
    });
  };

  return (
    <InputPercent
      label={label}
      value={percentageValue}
      placeholder={percentagePlaceholder}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
      decimalScale={3}
      numberOfDigits={3}
    />
  );
};

const mapStateToProps = (state) => ({
  placeholder: state?.rentvsbuyCalculator?.manualInputs?.propertyTaxRate,
  value: state?.rentvsbuyCalculator?.inputs?.propertyTaxRate,
  errorMessage: state?.validations?.propertyTaxRate?.[0],
});

export default connect(mapStateToProps)(PropertyTaxRateInput);
